/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SearchFilterSection from "../../components/common/SearchFilterSection";
import CompletedAppointment from "../../components/tables/CompletedAppointment";
import { getUniqueValues } from "../../libs/UnauthorisedPage";
import { getApiCaller } from "../../libs/apiCaller";

const CompletedAppointmentList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const providerId = location.state?.providerId;
  const providerName = location.state?.providerName;
  const type = location.state?.type;
  const [completeAppointments, setCompleteAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredCompleteAppointments, setFilteredCompleteAppointments] =
    useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const fetchCompleteAppoinments = async () => {
    try {
      const response = await getApiCaller(
        `provider_appointment_list?type=${type}&provider_id=${providerId}`
      );
      setCompleteAppointments(response.data.response_data);
      setFilteredCompleteAppointments(response.data.response_data);
      setStates(
        getUniqueValues(response?.data?.response_data, "billing_state")
      );
    } catch (error) {
      toast.error("Failed to fetch pending providers. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    providerId && fetchCompleteAppoinments();
  }, [providerId]);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedState, selectedCity]);

  const applyFilters = () => {
    let filteredData = completeAppointments;

    if (searchTerm) {
      filteredData = filteredData.filter((consumer) => {
        const fullName = `${consumer?.patient_name || ""}`?.toLowerCase();
        return fullName?.includes(searchTerm?.toLowerCase());
      });
    }

    if (selectedState) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_state === selectedState
      );
      setCities(getUniqueValues(filteredData, "billing_city"));
    } else {
      setCities(getUniqueValues(completeAppointments, "billing_city"));
    }

    if (selectedCity) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_city === selectedCity
      );
    }

    setFilteredCompleteAppointments(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedState("");
    setSelectedCity("");
    setFilteredCompleteAppointments(completeAppointments);
    setCities(getUniqueValues(completeAppointments, "billing_city"));
  };

  return (
    <>
      <div className="px-4 md:px-10 mt-4">
        <nav className="flex flex-col sm:flex-row sm:items-end justify-between mb-3">
          <div className="flex items-center space-x-2">
            <a
              href="/provider"
              className="text-[#284184] text-xl hover:underline"
            >
              All Providers
            </a>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <button
              href="/provider"
              className="text-[#284184] text-xl font-[Lato-Regular] hover:underline"
              onClick={() =>
                navigate("/providerProfile", {
                  state: { provider: { id: providerId } },
                })
              }
            >
              {providerName}
            </button>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <span className="text-[#284184] text-xl font-[Lato-Regular] font-bold">
              Completed Appointments
            </span>
          </div>
        </nav>
        <div className="border border-t-0 px-4 py-3 rounded-b-2xl text-xl bg-white">
          <SearchFilterSection
            searchTextPlaceholder={"Search Patient Name"}
            searchTerm={searchTerm}
            selectedCity={selectedCity}
            selectedState={selectedState}
            cities={cities}
            states={states}
            clearFilters={clearFilters}
            setSearchTerm={setSearchTerm}
            setSelectedCity={setSelectedCity}
            setSelectedState={setSelectedState}
          />
          <CompletedAppointment
            completeAppointments={filteredCompleteAppointments}
            loading={loading}
            providerId={providerId}
            providerName={providerName}
            type={type}
          />
        </div>
      </div>
    </>
  );
};

export default CompletedAppointmentList;
